import React, { useEffect } from 'react';
import Iframe from 'react-iframe';
import './CpaModal.css';

const CpaModal = ({ setShowModal }) => {
    useEffect(() => {
        document.body.style.overflowY = "hidden";
        return () => { document.body.style.overflowY = "scroll"; }
    }, []);

    return (
        <>
            {/* <div className="modal-wrapper bg-black opacity-60 fixed z-10 w-full top-0 left-0 right-0 bottom-0" onClick={() => setShowModal(false)}></div>
            <div className='p-6 border border-gray-600 z-10 bg-slate-400 w-[500px] h-auto fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'>
                <h1>This is modal Header</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est voluptates itaque doloribus dignissimos. Voluptatum consequatur laborum ipsum fuga ea amet incidunt saepe quo, suscipit esse ad alias culpa repudiandae facilis?</p>
                <button className='btn' onClick={() => setShowModal(false)}>Accept It</button>
            </div> */}

            {/* <div className="modal-wrapper bg-black opacity-60 fixed z-10 w-full top-0 left-0 right-0 bottom-0"></div> */}
            <div className="z-20 w-[500px] h-[500px] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
                <Iframe
                    src="https://d1ph51qsmnjpvt.cloudfront.net/public/i_fr?it=4075075&key=72848"
                    width="100%"
                    height="100%"
                    id=""
                    className=""
                    display="block"
                    marginwidth="0"
                    marginheight="0"
                    align="middle"
                />

            </div>
        </>
    );
};

export default CpaModal;
